import { usePage } from './use-page';
import { usePerPage } from './use-per-page';

export const useSkip = (): number => {
  const page = usePage();
  const perPage = usePerPage();

  return (page - 1) * perPage;
};
